var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_229_7057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.625 16.3125C8.3875 16.3125 4.9375 12.8625 4.9375 8.625C4.9375 4.3875 8.3875 0.9375 12.625 0.9375C16.8625 0.9375 20.3125 4.3875 20.3125 8.625C20.3125 12.8625 16.8625 16.3125 12.625 16.3125ZM12.625 2.0625C9.0025 2.0625 6.0625 5.01 6.0625 8.625C6.0625 12.24 9.0025 15.1875 12.625 15.1875C16.2475 15.1875 19.1875 12.24 19.1875 8.625C19.1875 5.01 16.2475 2.0625 12.625 2.0625Z",
    fill: "#239EC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 17.0626C20.3575 17.0626 20.215 17.0101 20.1025 16.8976L18.6025 15.3976C18.385 15.1801 18.385 14.8201 18.6025 14.6026C18.82 14.3851 19.18 14.3851 19.3975 14.6026L20.8975 16.1026C21.115 16.3201 21.115 16.6801 20.8975 16.8976C20.785 17.0101 20.6425 17.0626 20.5 17.0626Z",
    fill: "#239EC2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_229_7057",
    x: 0.9375,
    y: 0.9375,
    width: 24.123,
    height: 24.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_229_7057"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_229_7057",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNormal);
export default __webpack_public_path__ + "static/media/search-normal.a85834ca3d9bd209725f5e0c8828dd59.svg";
export { ForwardRef as ReactComponent };